module.exports = __webpack_public_path__ + "media/images/map-icons/icon2_unselected@2x-112989f49edba8f2195a4f49cb65761a.png";